import { gql } from '@apollo/client'

export const CREATE_BOOKING_DAILY = gql`
    mutation BookingCreateBooking(
        $email: String!
        $end_datetime: timestamptz!
        $lot_id: String!
        $plates: [InputBookingPlate!]
        $start_datetime: timestamptz!
        $total_amount: numeric!
        $shopper_locale: String!
    ) {
        booking_create_booking(
            email: $email
            end_datetime: $end_datetime
            lot_id: $lot_id
            plates: $plates
            start_datetime: $start_datetime
            total_amount: $total_amount
            shopper_locale: $shopper_locale
        ) {
            id
            booking_reference
            success
            unavailable_dates
        }
    }
`
